import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  auths: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  unAuths: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  shelfCheck: { data: null, params: null, visible: false, loading: false },
  detail: { data: null, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};


export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
